import { createEvent, restore, sample } from 'effector'
import { fx } from 'src/libs'
import {
  Coefficient,
  CoefficientListRequest,
  CoefficientListResponse,
  CoefficientUpdateRequest,
} from './types'

export const coefficientsListMounted = createEvent<CoefficientListRequest>()

export const getCoefficients = fx<
  CoefficientListRequest,
  CoefficientListResponse
>({
  method: 'GET',
  url: `/bonus150/coefficients`,
})

const MOCK_COEFFICIENTS: Coefficient[] = [
  {
    id: 1,
    base: 3.5,
    deals: 21,
    realAccountTradeExist: 4,
    realAccountTradeNotExist: 1,
    lots: 3.5,
    boosterLots05: 1,
    boosterLots1: 2,
    profitCap: 50,
    maxLots: 60,
  },
  {
    id: 2,
    base: 4,
    deals: 25,
    realAccountTradeExist: 5,
    realAccountTradeNotExist: 1,
    lots: 4,
    boosterLots05: 1.5,
    boosterLots1: 2.5,
    profitCap: 60,
    maxLots: 80,
  },
  {
    id: 3,
    base: 2.5,
    deals: 18,
    realAccountTradeExist: 3,
    realAccountTradeNotExist: 0.5,
    lots: 2.5,
    boosterLots05: 0.5,
    boosterLots1: 1,
    profitCap: 40,
    maxLots: 40,
  },
]

export const $coefficients = restore<Coefficient[]>(
  getCoefficients.doneData.map((a) => a.body.items),
  MOCK_COEFFICIENTS,
)

export const $totalCount = restore(
  getCoefficients.doneData.map((a) => a.body.total),
  MOCK_COEFFICIENTS.length,
)

sample({
  // @ts-ignore
  clock: coefficientsListMounted,
  fn: ({ limit, page }) => ({
    query: { limit, page },
  }),
  target: getCoefficients,
})

export const updateCoefficientFx = fx<any, any>({
  method: 'PUT',
  url: '/bonus150/coefficients/',
})

export const updateCoefficientTriggered = createEvent<CoefficientUpdateRequest>()

sample({
  clock: updateCoefficientTriggered,
  fn: ({ id, body }) => ({
    url: `/bonus150/coefficients/${id}`,
    body,
  }),
  target: updateCoefficientFx,
})
